
const newModel = () => {
    return {
        userId: null,
        userName: null,
        hoTen: null,
        gioiTinh: null,
        email: null,
        sdt: null,
        donViId: null,
        tenDonVi: null,
        chucDanhId: null,
        tenChucDanh: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        phuongXaId: null,
        tenPhuongXa: null,
        khomApId: null,
        tenKhomAp: null,
        toDanPhoId: null,
        tenToDanPho: null,
        duongPhoId: null,
        tenDuongPho: null,
        soNha: null,
        diaChi: null,
        lockoutEnabled: null,
        lockoutEnabledDisplay: null,
        lockoutTime: null,
        dateCreated: null,
        appId: null,
        appName: null,
        listRoleId: null,
        roleInfo: [],
    }
}

const newFEModel = () => {
    return {
        userId: null,
        userName: null,
        hoTen: null,
        gioiTinh: null,
        email: null,
        sdt: null,
        donViId: null,

        chucDanhId: null,

        quanHuyenId: null,

        phuongXaId: null,

        khomApId: null,

        toDanPhoId: null,

        duongPhoId: null,

        soNha: null,
        diaChi: null,
        lockoutEnabled: null,
        lockoutEnabledDisplay: null,
        lockoutTime: null,
        dateCreated: null,
        appId: null,
        appName: null,
        listRoleId: null,
        roleInfo: [],
    }
}

const fromJson = (item) => {
    return {
        userId: item.userId,
        userName: item.userName,
        hoTen: item.hoTen,
        gioiTinh: item.gioiTinh,
        email: item.email,
        sdt: item.sdt,
        donViId: item.donViId,
        tenDonVi: item.tenDonVi,
        chucDanhId: item.chucDanhId,
        tenChucDanh: item.tenChucDanh,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        khomApId: item.khomApId,
        tenKhomAp: item.tenKhomAp,
        toDanPhoId: item.toDanPhoId,
        tenToDanPho: item.tenToDanPho,
        duongPhoId: item.duongPhoId,
        tenDuongPho: item.tenDuongPho,
        soNha: item.soNha,
        diaChi: item.diaChi,
        lockoutEnabled: item.lockoutEnabled,
        lockoutEnabledDisplay: item.lockoutEnabled == 1 ? true : false,
        lockoutTime: item.lockoutTime,
        dateCreated: item.dateCreated,
        appId: item.appId,
        appName: item.appName,
        listRoleId: item.listRoleId,
        roleInfo: item.roleInfo,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        userId: item.userId,
        userName: item.userName,
        hoTen: item.hoTen,
        gioiTinh: item.gioiTinh,
        email: item.email,
        sdt: item.sdt,
        donViId: item.donViId,
        chucDanhId: item.chucDanhId,
        tenChucDanh: item.tenChucDanh,
        quanHuyenId: item.quanHuyenId,
        phuongXaId: item.phuongXaId,
        khomApId: item.khomApId,
        toDanPhoId: item.toDanPhoId,
        duongPhoId: item.duongPhoId,
        soNha: item.soNha,
        diaChi: item.diaChi,
        lockoutEnabled: item.lockoutEnabled,
        lockoutEnabledDisplay: item.lockoutEnabled == 1 ? true : false,
        lockoutTime: item.lockoutTime,
        dateCreated: item.dateCreated,
        appId: item.appId,
        listRoleId: item.listRoleId,
        roleInfo: item.roleInfo,
    }
}

const errors = () => {
    return {
        userId: null,
        userName: null,
        hoTen: null,
        gioiTinh: null,
        email: null,
        sdt: null,
        donViId: null,
        chucDanhId: null,
        tenChucDanh: null,
        quanHuyenId: null,
        phuongXaId: null,
        khomApId: null,
        toDanPhoId: null,
        duongPhoId: null,
        soNha: null,
        diaChi: null,
        lockoutEnabled: null,
        lockoutTime: null,
        dateCreated: null,
        appId: null,
        listRoleId: null,
        roleInfo: null,
    }
}

export const nguoiDungModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


